import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=4d8fad82&scoped=true"
import script from "./Form.js?vue&type=script&lang=js&external"
export * from "./Form.js?vue&type=script&lang=js&external"
import style0 from "./Form.scss?vue&type=style&index=0&id=4d8fad82&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8fad82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
